///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'


declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ProjectDeploymentReport/projectDeploymentReport.html'
})

export class ProjectDeploymentReportComponent implements OnInit {
    constants: Constants;
    projectDeploymentReportList: any = [];
    userDetail: any;
    projectList: any = [];
    objTotalTimeSpent: any =[];
    objSiteUserItem: any = [];
    public showLoader = false;

    filter: any = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'ByTask' : false };
    filterByTask: any = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() {
        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        //console.log(newDate)
        this.filter.FromDate = newDate;
        this.GetProjectList();
        this.GetProjectDeploymentReport();
    }

    ExportItems() {
        console.log(this.filterByTask );
        if (this.filterByTask == false) {
            ExportToExcel(this.projectDeploymentReportList, "Project Deployment Report",
                ["Username", "Project_Title", "TimeSpent"],
                ["User", "Project", "Time Spent (mins)"]);
        }
        else if (this.filterByTask == true) {
            ExportToExcel(this.projectDeploymentReportList, "Project Deployment Report",
                ["TaskTypeName", "Project_Title", "TimeSpent"],
                ["Task", "Project", "Time Spent (mins)"]);
        }

    }

    ngAfterViewInit() {



        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });

    }



    public clearFilter() {
        this.filter = { 'ProjectId': "", 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY'), 'ByTask': false };
        var dt = new Date();
        var month = new Array();
        month[0] = "01";
        month[1] = "02";
        month[2] = "03";
        month[3] = "04";
        month[4] = "05";
        month[5] = "06";
        month[6] = "07";
        month[7] = "08";
        month[8] = "09";
        month[9] = "10";
        month[10] = "11";
        month[11] = "12";
        var mth = month[dt.getMonth()];
        var yr = dt.getFullYear();
        var newDate = '01/' + mth + '/' + yr;
        //console.log(newDate)
        this.filter.FromDate = newDate;
    }

    GetProjectList() {
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            TeamId = this.userDetail.TeamID;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetAssignedProject",
            { "ProjectId": 0, "OwnerTeamId": TeamId, "ProjectType": 0, "Status": 1, "UserId": UserId }).subscribe(
            data => {
                this.projectList = data["ProjectList"];
            },
            err => {
                console.log("GetProjectList Failed");
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );      
    }



    GetProjectDeploymentReport() {
        var TeamId = 0
        // if(this.filter.TeamId == "")
        // {
            TeamId = this.userDetail.TeamID
        // }
        // else
        // {
        //     TeamId = this.filter.TeamId
        // }
        this.showLoader = true;
        this._httpService.ajaxPost("ProjectDeployment/GetProjectDeploymentReport",
            {
                "ProjectId": this.filter.ProjectId,
                "TeamId": TeamId,
                "FromDate": this.filter.FromDate,
                "ToDate": this.filter.ToDate,
                "UserId": null,
                "TaskId": null,
                "LoggedInUser":this.userDetail.SiteUserId,
                "ByTask": this.filter.ByTask
            }).subscribe(
                data => {
                    this.projectDeploymentReportList = data["ProjectDeploymentReport"];
                    this.objTotalTimeSpent = 0
                    this.projectDeploymentReportList.forEach(element => {
                        if (element.TimeSpent == "") {
                            element.TimeSpent = 0;
                        }
                        // else
                        // {
                        this.objTotalTimeSpent += parseInt(element.TimeSpent);
                        //}
                    });
                    this.filterByTask = this.filter.ByTask;
                },
                 err => {
                console.log("Get Project Deployment Report Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            ()=>{
                this.showLoader = false;
            });


    
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProjectDeploymentReport/projectDeploymentReport.component.ts
 **/